import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import TextPlugin from "gsap/TextPlugin";
import { returnBlueprintAnimation, returnCoordinateAnimation } from "../../app";
import initPage from "../page";

gsap.registerPlugin(TextPlugin, ScrollTrigger);

export default function defaultEnterDesktop(data, isMobile, isTouch) {
  if (isMobile) {
    if (data.next.container.querySelector(".page-special")) {
      return gsap
        .timeline()
        .set(".wipe-wrapper", {
          autoAlpha: 0,
        })
        .set(data.next.container, {
          autoAlpha: 1,
        })
        .set(".hide-on-load", {
          autoAlpha: 1,
        })
        .from(".block-1 h1", {
          autoAlpha: 0,
          xPercent: 10,
        })
        .from(
          ".block-1__content",
          {
            autoAlpha: 0,
            xPercent: 10,
          },
          "<50%"
        )
        .from(
          ".block-2",
          {
            autoAlpha: 0,
            yPercent: 10,
          },
          "<50%"
        );
    } else {
      return gsap
        .timeline()
        .set(".wipe-wrapper", {
          autoAlpha: 0,
        })
        .set(data.next.container, {
          autoAlpha: 1,
        })
        .set(".hide-on-load", {
          autoAlpha: 1,
        })
        .from(".page-regular__title", {
          autoAlpha: 0,
          xPercent: 10,
        })
        .from(
          ".page-regular__blurb",
          {
            xPercent: 10,
            autoAlpha: 0,
            duration: document.querySelector(".page-regular__blurb")
              ? gsap.defaults().duration
              : 0,
          },
          "<50%"
        )
        .from(
          ".page-regular__content",
          {
            autoAlpha: 0,
            yPercent: 10,
          },
          "<50%"
        );
    }
  }
  if (data.next.container.querySelector(".page-special")) {
    var block2Rect = document.querySelector(".block-2").getBoundingClientRect();
    var tl = gsap
      .timeline({
        onComplete: () => initPage(isMobile, isTouch),
      })
      .set(".wipe-wrapper", {
        autoAlpha: 0,
      })
      .set(data.next.container, {
        autoAlpha: 1,
      })
      .set(".hide-on-load", {
        autoAlpha: 1,
      })
      .from(".block-1 h1", {
        autoAlpha: 0,
        xPercent: -10,
      })
      .from(
        ".block-1--coord",
        {
          autoAlpha: 0,
        },
        "<"
      )
      .from(".block-1__content", {
        xPercent: 20,
        autoAlpha: 0,
      }, '<50%');
    returnCoordinateAnimation(tl, ".block-1 .coord", "<50%");
    tl.fromTo(
      ".draw-on-load",
      {
        drawSVG: "0%",
      },
      {
        drawSVG: "100%",
      },
      "<"
    );
    tl.from(
      ".block-3",
      {
        y: "100vh",
      },
      "<50%"
    ).from(
      ".block-2",
      {
        y: "100vh",
      },
      "<50%"
    );
    return tl;
  } else {
    tl = gsap
      .timeline()
      .set(".wipe-wrapper", {
        autoAlpha: 0,
      })
      .set(data.next.container, {
        autoAlpha: 1,
      })
      .set(".hide-on-load", {
        autoAlpha: 1,
      })
      .from(".page-regular__title", {
        autoAlpha: 0,
        xPercent: -10,
      })
      .from(
        ".page-regular__hero--coord",
        {
          autoAlpha: 0,
        },
        "<"
      )
      .from(".page-regular__blurb", {
        xPercent: 20,
        autoAlpha: 0,
        duration: document.querySelector(".page-regular__blurb")
          ? gsap.defaults().duration
          : 0,
      });
    returnCoordinateAnimation(tl, ".page-regular__hero--coord", "<");
    tl.fromTo(
      ".page-regular .draw-on-load",
      {
        drawSVG: "0%",
      },
      {
        drawSVG: "100%",
      },
      "<"
    ).from(".page-regular__content", {
      y: "100vh",
      autoAlpha: 0,
    });

    return tl;
  }
}
